export default "__VITE_ASSET__BcqdwHv9__"